import { AI_API_ACCESS_TOKEN_GREY_LABEL } from '@aca-new/app/shared/constants/ai-api-access-token.constants';
import { ECookieKeys } from '@aca-new/app/shared/models/enums/cookie-keys.enum';
import { EStorageKeys } from '@aca-new/app/shared/models/enums/storage-keys.enum';
import { CookieStorageService } from '@aca-new/app/shared/services/storage-services/cookie-storage/cookie-storage.service';
import { StorageService } from '@aca-new/app/shared/services/storage-services/storage.service';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';

@UntilDestroy()
@Injectable()
export class ExternalSharedReportHttpAuthInterceptor implements HttpInterceptor {
  public constructor(
    private readonly _cookieStorage: CookieStorageService,
    private readonly _storageService: StorageService
  ) {}

  public intercept<T>(request: Readonly<HttpRequest<T>>, next: Readonly<HttpHandler>): Observable<HttpEvent<T>> {
    const authToken = this._cookieStorage.get(ECookieKeys.EXTERNAL_REPORT_AUTH_TOKEN);
    const userId = this._storageService.getItem(EStorageKeys.USER_ID) ?? '';
    const pageToken = this._cookieStorage.get(ECookieKeys.EXTERNAL_REPORT_PAGE_TOKEN) || '';
    const setHeaders: Record<string, string> = {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'ai-api-access-token': AI_API_ACCESS_TOKEN_GREY_LABEL,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      'ai-api-external-app-id': pageToken,
    };

    if (authToken) {
      setHeaders['authorization'] = `Bearer ${authToken}`;
    }

    request = request.clone({
      url: request.url.replace(/(?<=user\/)[^/]*(?=\/)/, userId || pageToken),
      setHeaders,
    });

    return next.handle(request);
  }
}
